import React, {useContext} from 'react';

import { secureRequest } from 'utils/request';
import { useHistory } from 'react-router';
import { ErrorPage } from '../components/ErrorPage';
import {mainCordovaContext} from "../context";

export const AccessDenied: React.FC = () => {
  const history = useHistory();

  const { toggleNavigation } = useContext(mainCordovaContext)

  const handleClickRefresh = async () => {
    history.push('/');
    toggleNavigation();
  };

  return (
    <ErrorPage
      title="Нет доступа"
      actionButtonText="На главную"
      actionCallback={handleClickRefresh}
    >
    </ErrorPage>
  );
};
